import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import { Loading } from '@ncai-axe/react-ui-v3';
import styles from './styles.module.scss';
interface EditorLoadingSkeletonProps {
  /** Localized status line shown under the spinner (caller owns translation). */
  label: string;
}

/**
 * Shared editor loading affordance for the banner + detail(center) editors. Renders a centered
 * spinner + label over a faux canvas card so both editors show the SAME loading UX (previously banner
 * showed this skeleton while detail rendered nothing but a gray column). The host container
 * (`.fill` / `.editorFill`) provides the box; this fills it at 100% so loading↔loaded share dimensions
 * (no layout shift).
 */
export function EditorLoadingSkeleton(t0) {
  const $ = _c(4);
  const {
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.skeletonCanvas} aria-hidden={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Loading size={28} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <div className={styles.skeletonRoot}>{t1}<div className={styles.skeletonOverlay}>{t2}<span className={styles.skeletonLabel}>{label}</span></div></div>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}